import { AddonsParent, IAddonsData } from '@vacationtracker/shared/types/automations'
import { SubscriptionPlanEnum } from '@vacationtracker/shared/types/company'

export const getAddonsEvents = (formatMessage?: Function): IAddonsData[] => {
  // every new addon, integration or automation should be added here
  const addonsEvents = [
    {
      type: 'LEAVE_REQUEST_NOTICE_PERIOD',
      parent: AddonsParent.automations,
      parentLabel: formatMessage ? formatMessage({ id: 'app.automations' }) : 'AUTOMATIONS',
      roles: ['Admin', 'Approver'],
      url: 'leave-request-notice-period',
      includedIn: [SubscriptionPlanEnum.core, SubscriptionPlanEnum.complete],
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.leaveRequestNoticePeriodInfo' }) : '',
    },
    {
      type: 'BLACKOUT_PERIOD',
      parent: AddonsParent.automations,
      parentLabel: formatMessage ? formatMessage({ id: 'app.automations' }) : 'AUTOMATIONS',
      roles: ['Admin', 'Approver'],
      url: 'blackout-period',
      includedIn: [SubscriptionPlanEnum.complete],
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.blackoutPeriodInfo' }) : '',
      helpDesklink: 'https://vacationtracker.io/knowledge-base/how-to-set-a-blackout-period-block-time/',
    },
    {
      type: 'SENIORITY_ENTITLEMENT',
      parent: AddonsParent.automations,
      parentLabel: formatMessage ? formatMessage({ id: 'app.automations' }) : 'AUTOMATIONS',
      roles: ['Admin'],
      url: 'seniority-entitlement',
      includedIn: [SubscriptionPlanEnum.complete],
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.seniorityEntitlementShortInfo' }) : '',
      helpDesklink: 'https://vacationtracker.io/knowledge-base/how-do-i-set-up-seniority-based-entitlement-sbe-automation/',
    },
    {
      type: 'ENTITLEMENT_BY_ROLE',
      parent: AddonsParent.automations,
      parentLabel: formatMessage ? formatMessage({ id: 'app.automations' }) : 'AUTOMATIONS',
      roles: ['Admin'],
      url: 'entitlement-by-role',
      includedIn: [SubscriptionPlanEnum.complete],
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.enitlementByRoleShortInfo' }) : '',
      helpDesklink: 'https://vacationtracker.io/knowledge-base/how-do-i-set-entitlement-by-role/',
    },
    {
      type: 'VISIBILITY',
      parent: AddonsParent.addons,
      parentLabel: formatMessage ? formatMessage({ id: 'app.addons' }) : 'ADDONS',
      roles: ['Admin'],
      url: 'visibility',
      includedIn: [SubscriptionPlanEnum.complete],
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.visibilityInfo' }) : '',
      helpDesklink: 'https://vacationtracker.io/knowledge-base/how-do-i-limit-users-visibility/?bust=1723123359283',
    },
    {
      type: 'PROBATION_PERIOD',
      parent: AddonsParent.automations,
      parentLabel: formatMessage ? formatMessage({ id: 'app.automations' }) : 'AUTOMATIONS',
      roles: ['Admin', 'Approver'],
      url: 'probation-period',
      includedIn: [SubscriptionPlanEnum.complete],
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.employmentLeaveRestrictionInfo' }) : '',
    },
    {
      type: 'OPEN_API',
      parent: AddonsParent.integrations,
      parentLabel: formatMessage ? formatMessage({ id: 'app.integrations' }) : 'INTEGRATIONS',
      roles: ['Admin'],
      url: 'open-api',
      includedIn: [SubscriptionPlanEnum.core, SubscriptionPlanEnum.complete],
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.openApiInfo' }) : '',
    },
    {
      type: 'BAMBOOHR_INTEGRATION',
      parent: AddonsParent.integrations,
      parentLabel: formatMessage ? formatMessage({ id: 'app.integrations' }) : 'INTEGRATIONS',
      roles: ['Admin'],
      url: 'coming-soon',
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.bambooHrIntegration' }) : '',
    },
    {
      type: 'MAXIMUM_USERS_AWAY',
      parent: AddonsParent.automations,
      parentLabel: formatMessage ? formatMessage({ id: 'app.automations' }) : 'AUTOMATIONS',
      roles: ['Admin', 'Approver'],
      url: 'maximum-users-away',
      includedIn: [SubscriptionPlanEnum.complete],
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.teamLeaveBalancingInfo' }) : '',
    },
    {
      type: 'ADP',
      parent: AddonsParent.integrations,
      parentLabel: formatMessage ? formatMessage({ id: 'app.integrations' }) : 'INTEGRATIONS',
      roles: ['Admin'],
      url: 'adp',
      includedIn: [SubscriptionPlanEnum.core, SubscriptionPlanEnum.complete],
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.adpIntegration' }) : '',
    },
    {
      type: 'ZAPIER',
      parent: AddonsParent.integrations,
      parentLabel: formatMessage ? formatMessage({ id: 'app.integrations' }) : 'INTEGRATIONS',
      roles: ['Admin'],
      includedIn: [SubscriptionPlanEnum.core, SubscriptionPlanEnum.complete],
      url: 'zapier',
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.zapierIntegration' }) : '',
    },
    {
      type: 'LEAVE_DURATION_LIMIT',
      parent: AddonsParent.automations,
      parentLabel: formatMessage ? formatMessage({ id: 'app.automations' }) : 'AUTOMATIONS',
      roles: ['Admin', 'Approver'],
      url: 'leave-duration-limit',
      includedIn: [SubscriptionPlanEnum.complete],
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.leaveDurationLimitInfo' }) : '',
    },
    {
      type: 'HR_FIELDS',
      parent: AddonsParent.addons,
      parentLabel: formatMessage ? formatMessage({ id: 'app.addons' }) : 'ADDONS',
      roles: ['Admin', 'Approver'],
      url: 'coming-soon',
      description: formatMessage ? formatMessage({ id: 'choiceAutomations.hrFieldsInfo' }) : '',
    },
  ]

  return addonsEvents
}
